import { footerLinks } from "./navLinks";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 lg:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-gift-2-line text-lg" />
              </span>
              <span className="font-heading text-lg text-foreground-950">
                美味的快递
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              一个专注零食盲盒开箱与试吃记录的内容页面。我们拆盒、试吃、打分，把每一样零食的真实感受写下来，帮你在琳琅满目的盲盒里更快找到对胃口的那一款。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-refresh-line text-accent-700" />
              </span>
              每周三、周六更新开箱与试吃记录
            </div>
          </div>

          <nav aria-label="页内导航">
            <h3 className="font-heading text-base text-foreground-950">页内导航</h3>
            <ul className="mt-4 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base text-foreground-950">关于本站</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              本站仅做盲盒开箱与零食试吃的内容分享，所有口味评分均为试吃后的主观记录，存在个体差异。页面不提供下单、支付或配送，任何品牌与价格信息仅作为试吃时的参考。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 美味的快递 · 盲盒开箱与零食试吃记录
          </p>
          <p className="text-xs text-foreground-600">
            内容为个人记录分享，不构成购买建议
          </p>
        </div>
      </div>
    </footer>
  );
}